import getSummaries from '@/utils/mixins/transaction-get-summaries.js';
export default {
  mixins: [getSummaries],
  components: {
  },
  props: {
    previewContract: {
      type: Object,
      default: {}
    },
    massifType: {
      type: Array,
      default: []
    },
    closeBtn: {
      type: Boolean,
      default: false
    },
    projectSubType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      id: '',
      dialogFormVisible: true,
      citytitle: ''
    };
  },
  computed: {
    previewPageContract () {
      if (this.previewContract) {
        return JSON.parse(this.previewContract.assetsInfo);
      };
    },
    afterDatePayNextPrice () {
      if (this.previewContract && this.previewContract.afterDatePayNextPrice) {
        var json_date = new Date(this.previewContract.afterDatePayNextPrice).toJSON();
        var flag = new Date(new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').split(' ')[0];
        return flag.split('-')[1] + '月' + flag.split('-')[2];
      };
    }
  },
  created () {
    // console.log(this.previewContract, 'previewContract');
  },
  // mounted () {
  //   setTimeout(() => {
  //     console.log(this.previewPageContract, 'previewPageContract');
  //     if(this.previewPageContract) {
  //       this.previewPageContract.forEach(item => {
  //         item.manufactureDate = this.formatDate(new Date(new Date(item.manufactureDate).getTime() + 3600000 * 16 + 8 * 60 * 60 * 1000), 'yyyy年MM月dd日');
  //       });
  //     }
  //   }, 500);
  // },
  methods: {
    handleScroll () {
      const scrollTop = this.$refs.box.scrollTop; // 获取滑动距离
      if (scrollTop >= 1600) {
        this.$emit('enabledBtn');
      }
    },
    dialogFormClick () {
      this.$emit('dialogFormClick');
    },
    formatDate (date, fmt) {
      let o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (let k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
      return fmt;
    }
  }
};
